import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {TrackEventUBA, getUbaPageName} from '@jobseeker/common-core/utils';
import HeaderBtn from '@jobseeker/feature-navigation/components/Header/Containers/WithBtn';

import {useEffect, useState} from 'react';
import {AppState} from '@jobseeker/common-core/types';
import {HeaderPropType} from './types';

const HeaderNoAuth = (props: HeaderPropType) => {
  const {
    config: {
      showSearchBar = true,
      showDownloadApp = true,
      showJobSeeker = true,
      showRecruiter = true,
      showLogo = true,
    },
    ...prop
  } = props || {};

  const dispatch = useDispatch();

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const categoryId = useSelector(
    (state: AppState) => state.app.context.navigation.actualCategory,
    shallowEqual
  );
  const tagId = useSelector(
    (state: AppState) => state.app.context.navigation.tag,
    shallowEqual
  );

  const [aiSearchActive] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    const storedValue = localStorage.getItem('aiSearchActive');
    return storedValue === 'true';
  });

  const handleSearchBar = () => {
    TrackEventUBA('searchIconClick', aiSearchActive ? 'click_AI' : 'click', {
      page: getUbaPageName(),
      categoryID: page == 'category' ? categoryId : undefined,
      tagID: page == 'tag' ? Number(tagId) : undefined,
      sessionUsername: sessionStorage.getItem('userId') || '',
    });
    dispatch({
      type: 'AppContext/set_open_searchoverlay',
      payload: {search: true},
    });
  };

  const handleJobseeker = () => {};

  return (
    <HeaderBtn
      reCap={0}
      proMeta={{
        refCode: '',
        refFeature: '',
      }}
      config={{
        showSearchBar: showSearchBar,
        showDownloadApp: showDownloadApp,
        showJobSeeker: showJobSeeker,
        showRecruiter: showRecruiter,
        showLogo: showLogo,
      }}
      OnSearchBtnClick={handleSearchBar}
      OnJobseekerBtnClick={handleJobseeker}
      {...prop}
    />
  );
};

export default HeaderNoAuth;
